import React, { useCallback, useState } from 'react';
import DocumentViewContext, { MixpanelProps } from './DocumentView.context';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import useCallbackRef from 'hooks/useCallbackRef';
import { OverlayRef } from 'ncoded-component-library/build/components/atoms/Overlay/Overlay.component';
import DataroomNodeViewModal from 'components/DataroomNodeViewModal';
import { getIsNodeFile } from 'utils';
import DataRoomProgression from 'router/subrouters/DataRoom/components/DataRoomProgression';

const DocumentView: React.FC = (props) => {
  const { children } = props;

  const [node, setNode] = useState<DataRoomNode>();
  const [mixPanelProps, setMixPanelProps] = useState<MixpanelProps>();

  const [previewModal, previewModalRef] = useCallbackRef<OverlayRef>();

  const { dataRoomName, userSide, ownerId } = mixPanelProps || {};

  const openNode = useCallback(
    (node: DataRoomNode, props?: MixpanelProps) => {
      if (getIsNodeFile(node)) {
        setNode(node);

        if (props) setMixPanelProps(props);

        previewModal?.open();
      }
    },
    [previewModal],
  );

  return (
    <DocumentViewContext.Provider value={{ openNode }}>
      <DataroomNodeViewModal
        ref={previewModalRef}
        node={node}
        dataRoomName={dataRoomName}
        ownerId={ownerId}
        userSide={userSide}
      />
      {children}

      <DataRoomProgression dataRoomId={node?.dataRoomId} />
    </DocumentViewContext.Provider>
  );
};

export default DocumentView;
